import pl from "@locales/patient/programs_grid/pl.json";
import en from "@locales/patient/programs_grid/en.json";

export default {
  pl: pl,
  en: en,
};
